// MultiSelectField.tsx
import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  OutlinedInput, 
  Chip, 
  Box, 
  FormHelperText,
  SelectChangeEvent
} from '@mui/material';
import { FieldProps } from 'formik';

interface Option {
  value: number;
  label: string;
}

interface MultiSelectFieldProps extends FieldProps<number[]> {
  label: string;
  options: Option[];
}


export const MultiSelectField: React.FC<MultiSelectFieldProps> = (props) => {
  const { field, form, meta, label, options } = props;
  const showError = Boolean(meta?.touched && meta?.error);

  const handleChange = (event: SelectChangeEvent<number[]>) => {
    const { value } = event.target;
    // На случай, если MUI вернет строку, превращаем её в массив
    const newValue = typeof value === 'string' ? value.split(',').map(Number) : value;
    form.setFieldValue(field.name, newValue);
  };

  return (
    <FormControl fullWidth error={showError} sx={{ mt: 2, mb: 1 }}>
      <InputLabel id={`${field.name}-label`}>{label}</InputLabel>
      <Select
        {...field}
        labelId={`${field.name}-label`}
        multiple
        // ГАРАНТИРУЕМ МАССИВ: если в field.value лежит undefined/null, используем []
        value={field.value || []} 
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {(selected as number[]).map((val) => {
              const option = options.find((opt) => opt.value === val);
              return <Chip key={val} label={option?.label || val} size="small" />;
            })}
          </Box>
        )}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {showError && <FormHelperText>{meta?.error}</FormHelperText>}
    </FormControl>
  );
};